import { TableState } from "../../../../shared/components/TableState";
import { ApprovalRow } from "./ApprovalRow";
import type {
  useApprovalsWorkspace,
} from "./useApprovalsWorkspace";

export function ApprovalQueue({ model }: { model: ReturnType<typeof useApprovalsWorkspace>; }) {
  const {
    query,
    loading,
    returnedDecisions,
    showReturnedQueue,
    orderedVisibleRows,
  } = model;
  return (<>
    {loading ? (
      <TableState
        title="Onay kayıtları yükleniyor"
        description="Yetki alanınızdaki talepler getiriliyor."
      />
    ) : orderedVisibleRows.length ? (
      <div className="manager-dossier-table procurement-work-list procurement-queue-surface">
        <div
          className="manager-dossier-list-header procurement-queue-header"
          aria-hidden="true"
        >
          <span>Ürün / Talep</span>
          <span>Birim fiyat</span>
          <span>Miktar</span>
          <span>Önerilen tedarikçi</span>
          <span>Talep tarihi</span>
          <span>Mevcut durum</span>
          <span />
        </div>
        <section className="approval-list" aria-label="Karar dosyaları">
          {orderedVisibleRows.map(request => <ApprovalRow key={request.id} request={request} model={model} />)}
        </section>
      </div>
    ) : !showReturnedQueue || returnedDecisions.length === 0 ? (
      <TableState
        title={query ? "Eşleşen dosya bulunamadı" : "Bu durumda dosya yok"}
        description={
          query
            ? "Arama ifadesini değiştirin veya başka bir durum seçin."
            : "Seçili durumla eşleşen satın alma dosyası bulunmuyor."
        }
      />
    ) : null}
  </>);
}
